import { render, staticRenderFns } from "./VideoDeviceSelect.vue?vue&type=template&id=08acde08&scoped=true&"
import script from "./VideoDeviceSelect.vue?vue&type=script&lang=js&"
export * from "./VideoDeviceSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08acde08",
  null
  
)

export default component.exports